// @ts-nocheck
import React from 'react';
import css from '../shared/css';

interface Props {
  children: React.ReactNode;
}

export const AddMemberTable: React.FC<Props> = ({ children }: Props) => (
  <div className={styles.container}>
    <div className={styles.headersContainer}>
      <p className={styles.headers}>Email</p>
      <p className={styles.headers}>First Name</p>
      <p className={styles.headers}>Last Name</p>
      <p className={styles.headers}>Role</p>
      <p />
    </div>
    {children}
  </div>
);

const styles = css({
  container: {
    padding: 10,
    background: '#f5f4f1',
    border: '1px solid #bbbbbb',
    borderRadius: 7,
    margin: '15px 0 5px',
  },
  headersContainer: {
    display: 'grid',
    gridTemplateColumns: '255px 185px 185px 163px 25px',
    margin: 0,
    gridGap: 3,
  },
  headers: {
    marginBottom: 0,
    paddingLeft: 5,
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 900,
  },
});
